export default function ScheduleSection() {
  const scheduleItems = [
    { date: '2026年3月', content: 'プロジェクト公開', icon: 'ri-rocket-line' },
    { date: '2026年4月', content: 'プロジェクト終了', icon: 'ri-flag-line' },
    { date: '2026年4月', content: '最終仕様確定・量産開始', icon: 'ri-settings-3-line' },
    { date: '2026年5月', content: '製造完了', icon: 'ri-checkbox-circle-line' },
    { date: '2026年6月', content: '国内倉庫へ納品', icon: 'ri-building-2-line' },
    { date: '2026年6月より', content: '順次発送開始', icon: 'ri-truck-line' },
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* セクションタイトル */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
            <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">Schedule</p>
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            スケ<span className="text-[#8B6BAE]">ジュール</span>
          </h2>
          <p className="text-base text-[#6B6B6B] font-light">
            プロジェクトの進行予定をご案内します
          </p>
        </div>

        {/* タイムライン */}
        <div className="relative">
          {/* 縦線 */}
          <div className="absolute left-6 md:left-1/2 md:-translate-x-px top-0 bottom-0 w-px bg-[#E8E8E8]"></div>

          <div className="space-y-6">
            {scheduleItems.map((item, index) => (
              <div 
                key={index} 
                className={`relative flex items-center gap-6 md:gap-0 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* 日付（デスクトップ） */}
                <div className={`hidden md:block md:w-1/2 ${index % 2 === 0 ? 'md:pr-10 md:text-right' : 'md:pl-10 md:text-left'}`}>
                  <span className="text-sm font-medium text-[#8B6BAE]">{item.date}</span>
                </div>

                {/* ドット */}
                <div className="relative z-10 shrink-0">
                  <div className="w-10 h-10 bg-white border-2 border-[#8B6BAE] rounded-full flex items-center justify-center">
                    <i className={`${item.icon} text-base text-[#8B6BAE]`}></i>
                  </div>
                </div>

                {/* 内容 */}
                <div className={`flex-1 md:w-1/2 ${index % 2 === 0 ? 'md:pl-10' : 'md:pr-10'}`}>
                  <div className="bg-[#F8F6FA] py-3 px-5 rounded-xl border border-[#E8E8E8]">
                    <span className="text-sm font-medium text-[#8B6BAE] md:hidden block mb-0.5">{item.date}</span>
                    <p className="text-sm text-[#2C2C2C] font-medium">{item.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 注意書き */}
        <div className="mt-12 text-center">
          <p className="text-sm text-[#9B9B9B] bg-[#F8F6FA] inline-block px-5 py-2.5 rounded-full border border-[#E8E8E8]">
            ※製造状況や物流事情により前後する可能性がございます
          </p>
        </div>
      </div>
    </section>
  );
}
